export function getVersion() {
  const npmPackageConfiguration = require("../../../npm/package-esm.json");
  const releaseCandidatePrefix = "-RC";
  let releaseCandidate = null;

  const splitVersion = npmPackageConfiguration.version.split(".");
  const major = Number(splitVersion[0]);
  const minor = Number(splitVersion[1]);
  let patch = splitVersion[2];

  if (patch.includes(releaseCandidatePrefix)) {
    // We have a release candidate version, so we need to split the patch and the release candidate
    const splitPatch = patch.split(releaseCandidatePrefix);
    patch = Number(splitPatch[0]);
    releaseCandidate = Number(splitPatch[1]);
  } else {
    // No release candidate version available, so we can just parse the patch
    patch = Number(patch);
  }

  return {
    version: npmPackageConfiguration.version,
    major,
    minor,
    patch,
    releaseCandidate,
  };
}
